import React, { Component } from "react";
import AppBar from "@material-ui/core/AppBar";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Tabs from "@material-ui/core/Tabs";
import Paper from "@material-ui/core/Paper";

import Tab from "@material-ui/core/Tab";
import { Redirect, withRouter } from "react-router-dom";

import "./Header.css";
import { Link } from "react-router-dom";
import VideoPlayer from "../VideoPlayer/VideoPlayer";
import SimpleModal from "../Modal/Modal";
import { isMobile } from "react-device-detect";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalOpen: false,
      imageWidth: 150,
      imageStyle: "ImageHeader",
      open: false
    };
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = event => {
    const { scrollY } = window;
    const { active } = this.state;
    if (scrollY < 70) {
      //  if (window.innerHeight <= 700) {
      this.setState({ imageStyle: "ImageHeader" });
      //  } else {
      //    this.setState({ imageHeight: 250 });
      //   }
    } else {
      // if (window.innerHeight <= 700) {
      this.setState({ imageStyle: "ImageHeaderSmall" });
      // } else {
      //   this.setState({ imageHeight: 200 });
      // }
    }
  };

  onOpenVideoPlayer = () => {
    this.setState({ modalOpen: true });
  };

  onCloseVideoPlayer = () => {
    this.setState({ modalOpen: false });
  };

  onClickRedirect = () => {
    this.props.history.push("/");
  };

  onClickRedirectHome = () => {
    this.props.history.push("/?redirect=true");
  };

  render() {
    return (
      <div className={isMobile ? "HeaderMobile" : "Header"}>
        <Link to="/?redirect=true">
          <div className="LinkHeader"></div>
        </Link>
        {isMobile ? (
          <React.Fragment>
            <div className="MenuNavBar">
              <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={this.handleClick}
                className="MenuButton"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                open={this.state.open}
                onClose={this.handleClose}
                className="MenuNav"
                anchorEl={this.state.anchorEl}
              >
                <MenuItem
                  key={"1"}
                  selected={false}
                  onClick={this.onClickRedirect}
                >
                  {"COMO COMPRAR"}
                </MenuItem>
                <MenuItem
                  key={"2"}
                  selected={false}
                  onClick={this.onClickRedirectHome}
                >
                  {"AUTOS EN STOCK"}
                </MenuItem>
                <MenuItem
                  key={"9"}
                  selected={false}
                  onClick={this.onClickRedirect}
                >
                  {"FAQ"}
                </MenuItem>
                <MenuItem
                  key={"10"}
                  selected={false}
                  onClick={this.handleClose}
                >
                  {"CONTACTO"}
                </MenuItem>
                ))
              </Menu>
            </div>
          </React.Fragment>
        ) : (
          <div>
            <div className="Button-container">
              <Link to="/?redirect=true">
                <div className="Button-header">AUTOS EN STOCK</div>
              </Link>{" "}
              <img src="/img/divider.png" className="Divider" />
              <Link onClick={this.onOpenVideoPlayer}>
                <div className="Button-header">¿CÓMO COMPRAR? </div>
              </Link>
              <img
                src="/img/cero-vueltas.png"
                className={this.state.imageStyle}
                //style={{ height: this.state.imageHeight }}
              />
            </div>

            <SimpleModal
              open={this.state.modalOpen}
              onClose={this.onCloseVideoPlayer}
            >
              <VideoPlayer />
            </SimpleModal>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Header);
